import React from 'react';
import { Container, SkeletonCard, ShimmerBox } from './styles';

var SummarySkeleton = function() {
  return (
    <Container>
      {[1, 2, 3, 4, 5, 6, 7].map(function(index) {
        return (
          <SkeletonCard key={index}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%', alignItems: 'center' }}>
              <ShimmerBox width="60px" height="12px" />
              <ShimmerBox width="40px" height="28px" />
              <ShimmerBox width="80px" height="10px" />
            </div>
          </SkeletonCard>
        );
      })}
    </Container>
  );
};

export default SummarySkeleton;
